export const order_status = [
    { label: 'Order Shipped and Paid', value: 'Order Shipped and Paid' },
    { label: 'Order Shipped in Full', value: 'Order Shipped in Full' },
    { label: 'Order Cancelled', value: 'Order Cancelled' },
    { label: 'Order in Production', value: 'Order in Production' },
    { label: 'Returned Parts Received by PartsBadger', value: 'Returned Parts Received by PartsBadger' },
    {
        label: 'Order Shipped in Partial; Remaining Parts in Production',
        value: 'Order Shipped in Partial; Remaining Parts in Production',
    },
    { label: 'Order Processed', value: 'Order Processed' },
    { label: 'Full Order Undergoing Final Quality Check', value: 'Full Order Undergoing Final Quality Check' },
    { label: 'In Review', value: 'In Review' },
    { label: 'Partial Order Undergoing Final Quality Check', value: 'Partial Order Undergoing Final Quality Check' },
];
